// src/pages/ServicesPage.js
import React, { useEffect, useState } from "react";
import "./ServicesPage.css";
import { useNavigate } from "react-router-dom";
import { auth, db, storeage } from "../Firebase/Config";
import {
  collection,
  addDoc,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

function ServicesPage() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    description: "",
    files: [],
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((firebaseUser) => {
      if (!firebaseUser) {
        navigate("/verify");
      } else {
        setUser(firebaseUser);
        setFormData((prev) => ({
          ...prev,
          name: firebaseUser.displayName || "",
          email: firebaseUser.email || "",
        }));
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      files: Array.from(e.target.files),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const docRef = await addDoc(collection(db, "estimates"), {
        uid: user.uid,
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        description: formData.description,
        timestamp: serverTimestamp(),
      });

      const imageURLs = [];

      if (formData.files.length > 0) {
        const uploadPromises = formData.files.map(async (file) => {
          const storageRef = ref(
            storeage,
            `user_uploads/${user.uid}/${docRef.id}/${file.name}`
          );
          await uploadBytes(storageRef, file);
          const downloadURL = await getDownloadURL(storageRef);
          imageURLs.push(downloadURL);
          return downloadURL;
        });

        await Promise.all(uploadPromises);
      }

      await updateDoc(docRef, { imageURLs });

      setSubmitStatus("success");
      setFormData({
        name: user.displayName || "",
        email: user.email || "",
        phone: "",
        description: "",
        files: [],
      });
    } catch (error) {
      console.error("Submission error:", error);
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="services-page">
      <section className="services-header">
        <h1>Our Professional Services</h1>
        <p>Get an estimate for your project today</p>
      </section>

      <section className="estimate-form-section">
        <div className="form-container">
          <h2>Request an Estimate</h2>
          <form onSubmit={handleSubmit} className="estimate-form">
            <div className="form-group">
              <label htmlFor="name">Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Phone Number *</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="description">Project Description *</label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                rows="4"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="files">Upload Photos (Optional)</label>
              <input
                type="file"
                id="files"
                name="files"
                onChange={handleFileChange}
                multiple
                accept="image/*"
                className="file-input"
              />
            </div>

            <button
              type="submit"
              className="submit-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Get Estimate"}
            </button>

            {submitStatus === "success" && (
              <div className="success-message">
                Thank you! We'll get back to you soon.
              </div>
            )}
            {submitStatus === "error" && (
              <div className="error-message">
                Something went wrong. Please try again.
              </div>
            )}
          </form>
        </div>
      </section>
    </div>
  );
}

export default ServicesPage;
